// @ts-nocheck
import { useTranslation } from '@eti/providers';
import { price as priceUtil } from '@eti/utils';
import { Icon } from '@eti/components';
import { SeatCharacteristic as SeatCharacteristicEnum } from '@eti/schema-types';
import { useMemo } from 'react';
import { Heading } from '@etg/wings';
import getTranslatedTexts from '../../../../common/text-resolvers/utils/getTranslatedTexts';
import { getSeatIconId } from '../../../utils/seat';
import { SeatWrapper, TextContent, IconWrapper } from './StyledComponents';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SeatCharacteristic = _ref => {
  let {
    isOpen = false,
    characteristic,
    priceFrom,
    isUnavailable
  } = _ref;
  const {
    t
  } = useTranslation();
  const labels = getTranslatedTexts({
    priceFromLabel: 'Product.SeatMap.Characteristic.PriceFrom.Text',
    standardLabel: 'Product.SeatMap.Characteristic.Standard.Label',
    standardDescription: 'Product.SeatMap.Characteristic.Standard.Description',
    frontRowLabel: 'Product.SeatMap.Characteristic.FrontRow.Label',
    frontRowDescription: 'Product.SeatMap.Characteristic.FrontRow.Description',
    legroomLabel: 'Product.SeatMap.Characteristic.ExtraLegroom.Label',
    legroomDescription: 'Product.SeatMap.Characteristic.ExtraLegroom.Description',
    economyComfortLabel: 'Product.SeatMap.Characteristic.EconomyComfort.Label',
    economyComfortDescription: 'Product.SeatMap.Characteristic.EconomyComfort.Description',
    unavailableLabel: 'Product.SeatMap.Characteristic.Unavailable.Label',
    unavailableDescription: 'Product.SeatMap.Characteristic.Unavailable.Description'
  }, t);
  const [label, description] = useMemo(() => {
    if (isUnavailable) {
      return [labels.unavailableLabel, labels.unavailableDescription];
    }
    switch (characteristic) {
      case SeatCharacteristicEnum.LegSpace:
        return [labels.legroomLabel, labels.legroomDescription];
      case SeatCharacteristicEnum.FrontOfCabin:
        return [labels.frontRowLabel, labels.frontRowDescription];
      case SeatCharacteristicEnum.EconomyComfort:
        return [labels.economyComfortLabel, labels.economyComfortDescription];
      case SeatCharacteristicEnum.Normal:
      default:
        return [labels.standardLabel, labels.standardDescription];
    }
  }, [isUnavailable, characteristic, labels.unavailableLabel, labels.unavailableDescription, labels.legroomLabel, labels.legroomDescription, labels.frontRowLabel, labels.frontRowDescription, labels.economyComfortLabel, labels.economyComfortDescription, labels.standardLabel, labels.standardDescription]);
  return /*#__PURE__*/_jsxs(SeatWrapper, {
    isOpen: isOpen,
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      isOpen: isOpen,
      size: isOpen ? '2.375' : '1',
      children: /*#__PURE__*/_jsx(Icon, {
        id: isUnavailable ? 'c_flat-seat-unavailable' : getSeatIconId(characteristic),
        size: isOpen ? '38px' : '16px'
      })
    }), /*#__PURE__*/_jsxs(TextContent, {
      isOpen: isOpen,
      children: [/*#__PURE__*/_jsx(Heading, {
        level: 3,
        children: label
      }), !isUnavailable && /*#__PURE__*/_jsxs("span", {
        children: [labels.priceFromLabel, ": ", priceUtil.formatPrice(priceFrom)]
      }), isOpen && /*#__PURE__*/_jsx("p", {
        children: description
      })]
    })]
  });
};
export default SeatCharacteristic;